import React from 'react';
import OverseaCardForm from './OverseaCardForm';
export default ()=> <OverseaCardForm/>;



// WEBPACK FOOTER //
// ./src/pages/OverseaCard/OverseaCardCreate.js